// extracted by mini-css-extract-plugin
export default {"box_wrapper":"Checkbox_box_wrapper__LCWRn","box":"Checkbox_box__hmqkw","minus":"Checkbox_minus__HLBr1"};